const PaxgoldCnt = {
  symbol: "PAXG",
  name: "Paxgold",
  meta: {
    title: "Buy Paxgold | Sell Paxgold | Paxgold prices and charts",
    description:
      "Paxgold Digital Currency is a fixed-price, dollar-backed digital currency. Dye's goal is to make each Dye equal to $ 1 forever. Buy and sell Paxgold currency code at the best price, lowest commission and fastest time in coinnik Market.",
    keywords: "Paxgold, buy Paxgold, sell Paxgold, Paxgold price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: " چگونه پکس گلد بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید بایننس کوین کنید. قیمت پکس گلد در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول پکس گلد کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "برای ذخیره پکس گلد می‌توانید از انواع کیف‌پول‌های معتبر استفاده کنید. از بین کیف‌پول‌های سخت افزاری لجر بهترین گزینه است. از بین کیف‌پول‌های نرم افزاری نیز می‌توانید از تراست ولت و سایر کیف‌پول‌های اتریوم برای نگهداری رمز ارز PAXG استفاده کنید.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توان پکس گلد را نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در کوین‌نیک مارکت یک کیف پول اختصاصی و امن پکس گلد دارید، که می‌توانید رمز ارز پکس گلد خود را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا پکس گلد ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " پکس گلد یک استیبل کوین با پشتوانه است پس سرمایه‌گذاری در آن دقیقا مانند سرمایه‌گذاری در بازار طلا است. بهترین استفاده پکس گلد این است که به عنوان راهی برای حفظ سرمایه از آن استفاده کنیم یا برای انتقال سریع دلار به صورت دیجیتالی.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Paxgold",
      answer: "Buy_Paxgold",
      id: "toggler1",
    },
    {
      question: "What is the best Paxgold wallet?",
      answer: "Paxgold_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Paxgold at coinnik Market?",
      answer: "Keep_Paxgold_description",
      id: "toggler3",
    },
    {
      question: "Is Paxgold worth the investment?",
      answer: "Paxgold_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Paxgold",
        subTitle: "What is Paxgold?",
        content: "Paxgold_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Paxgold",
        content: "Paxgold_history_description",
        btnTitle: "Buy and sell Paxgold",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell Paxgold without intermediaries in coinnik Market",
        subTitle: "Buy Paxgold",
        content: "Buy_Paxgold_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Paxgold",
        content: "Sell_Paxgold_description",
        btnTitle: "Buy and sell Paxgold",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Paxgold analysis on the blog",
  informationTitle: "Paxgold market statistics and information",
};

export default PaxgoldCnt;
